import { jsx } from "panel";
import { SpinnerEl } from "common/components/spinner";
import { SvgIconEl } from "common/components/svg-icon";
import { SpinnerColor } from "../spinner/types";
import { ExperimentalTooltipEl } from "../tooltip";
import { ButtonTheme, ButtonType } from "./constants";
export function template() {
  const theme = this.attr(`theme`);
  const layout = this.attr(`layout`);
  const isPrimary = theme === ButtonTheme.Primary;
  const content = this.getContent();
  const iconOnly = this.isIconOnly();
  const isDestructive = this.attr(`type`) === ButtonType.Destructive || this.attr(`icon`) === `trashcan`;
  const isPressed = this.attr(`pressed`);
  const isIconHighlighted = this.attr(`highlight-icon`);
  const tooltip = this.params.tooltip || this.attr(`tooltip`);
  const displayTooltip = tooltip && !this.attr(`pressed`);
  const linkAttrs = {
    ...this.attr(`href`) && { href: this.attr(`href`) },
    ...this.attr(`target`) && { target: this.attr(`target`) },
    ...this.attr(`download`) && { download: this.attr(`download`) }
  };
  return /* @__PURE__ */ jsx(
    "a",
    {
      sel: ".mp-button-container",
      attrs: { ...linkAttrs, elref: `buttonContainer` },
      class: {
        [`mp-button-${theme}`]: true,
        [`mp-button-layout-${layout}`]: true,
        [`type-${this.attr(`type`)}`]: true,
        "type-destructive": isDestructive,
        "is-icon-only": iconOnly,
        "is-pressed": isPressed,
        "is-disabled": this.attr(`disabled`),
        "disable-pressed-styles": this.attr(`disable-pressed-styles`)
      },
      on: {
        click: this.handleClick
      }
    },
    /* @__PURE__ */ jsx("div", { sel: ".mp-button-animation-layer" }),
    /* @__PURE__ */ jsx("div", { sel: ".mp-button-content" }, this.attr(`icon`) === `spinner` ? /* @__PURE__ */ jsx(
      SpinnerEl,
      {
        key: "button-spinner",
        attrs: {
          color: isPrimary ? SpinnerColor.White : SpinnerColor.Blue
        }
      }
    ) : this.attr(`icon`) ? /* @__PURE__ */ jsx(SvgIconEl, { key: "button-icon", attrs: { icon: this.attr(`icon`) }, class: { highlighted: isIconHighlighted } }) : null, content ? /* @__PURE__ */ jsx("slot", { sel: ".mp-button-content-text" }) : null),
    displayTooltip && /* @__PURE__ */ jsx(
      ExperimentalTooltipEl,
      {
        attrs: {
          "delay-in": 10,
          "delay-out": 10,
          ...tooltip
        },
        params: {
          text: tooltip.text
        },
        props: { parentEl: this }
      }
    )
  );
}
